<template>
  <div class="posr"
       :class="{'zitop': showChoices}">
    <button
      class="a-btn a-btn--border btn-filter btn-filter-dark btn-filter-select"
      v-on:click.prevent="toggle()">
      {{filterLabel}}
      <span
        class="btn-filter-select__selected-value"
        v-show="hasSelectedChoice">
        {{selectedChoiceLabel}}
      </span>
      <i class="ico ico-angle-down"></i>
    </button><button
      class="btn btn-filter-select__reset-btn"
      v-if="hasSelectedChoice" v-on:click.prevent="reset()">
      <span class="sr-only">Clear</span>
      <i class="icon icon-times"></i>
    </button>
    <div class="btn-filter-select__choices" v-show="showChoices">
      <button
        v-for="choice in choices"
        :key="choice.value"
        v-on:click.prevent="click(choice)">
        {{choice.label}}
        <i class="ico ico-ok" v-if="selectedChoices.indexOf(choice.value) !== -1">
          <span class="sr-only">selected</span>
        </i>
      </button>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      filter: {
        type: Object,
        required: true
      },
      alreadyOpened: {
        type: Number,
        required: false
      }
    },
    data: function () {
      return {
        selectedChoices: [],
        showChoices: false,
        componentId: Math.random() * 10000
      }
    },
    computed: {
      filterLabel () {
        return this.filter.placeholder
      },
      hasSelectedChoice () {
        return this.selectedChoices.length > 0
      },
      filterSelected () {
        return this.filter.selected
      },
      choices () {
        return this.filter.boolean ? this.booleanChoices : this.filter.list
      },
      selectedChoiceLabel () {
        return this.selectedChoices.map(selectedChoiceValue =>
          this.choices
            .find(choice => choice.value === selectedChoiceValue).label)
          .join(', ')
      },
      booleanChoices () {
        if (this.filter.list.length < 2) {
          return []
        }

        return [{
          label: this.copyYes,
          value: this.filter.list[0].value,
          related_entries: this.filter.list[0].related_entries
        }, {
          label: this.copyNo,
          value: this.filter.list[1].value,
          related_entries: '0'
        }]
      },
      copyYes () {
        return this.$store.getters.copy('yes')
      },
      copyNo () {
        return this.$store.getters.copy('no')
      }
    },
    watch: {
      alreadyOpened (id) {
        if (id !== this.componentId) {
          this.showChoices = false
        }
      },
      filterSelected (s) {
        if (s.length === 0) {
          this.selectedChoices = []
        }
      }
    },
    methods: {
      toggle () {
        this.showChoices = !this.showChoices

        if (this.showChoices) {
          this.$emit('onOpen', this.componentId)
        }
      },
      reset () {
        this.selectedChoices = []
        this.showChoices = false
        this.$store.dispatch('setFilter', {
          key: this.filter.key,
          value: []
        })
      },
      click (choice) {
        const choiceIndex = this.selectedChoices.indexOf(choice.value)
        if (choiceIndex !== -1) {
          this.selectedChoices.splice(choiceIndex, 1)
        } else {
          if (!this.filter.multiple && this.selectedChoices.length > 0) {
            this.selectedChoices = []
          }
          this.selectedChoices.push(choice.value)
        }
        this.showChoices = false
        this.$store.dispatch('setFilter', {
          key: this.filter.key,
          value: this.selectedChoices.slice(0)
        })
      }
    }
  }
</script>

<style>
  .zitop {
    z-index: 220;
  }
</style>



// WEBPACK FOOTER //
// src/components/filter/FilterSelectV2.vue